import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

/* Layout */
import Layout from '../views/layout/Layout'

/**
 * hidden: true                   if `hidden:true` will not show in the sidebar(default is false)
 * alwaysShow: true               if set true, will always show the root menu, whatever its child routes length
 *                                if not set alwaysShow, only more than one route under the children
 *                                it will becomes nested mode, otherwise not show the root menu
 * redirect: noredirect           if `redirect:noredirect` will no redirct in the breadcrumb
 * name:'router-name'             the name is used by <keep-alive> (must set!!!)
 * meta : {
    title: 'title'               the name show in submenu and breadcrumb (recommend set)
    icon: 'svg-name'             the icon show in the sidebar,
  }
 **/
export const constantRouterMap = [
  { path: '/login', component: () => import('@/views/login/index'), hidden: true },
  { path: '/404', component: () => import('@/views/404'), hidden: true },
  {
    path: '',
    component: Layout,
    redirect: '/home',
    meta: { title: '首页', icon: 'home' },
    children: [{
      path: 'home',
      name: 'home',
      component: () => import('@/views/home/index'),
      meta: { title: '首页', icon: 'home' }
    }
    ]
  }
]

export const asyncRouterMap = [
  {
    path: '/booking',
    component: Layout,
    redirect: '/booking/store',
    name: 'booking',
    sort: 50,
    meta: { title: '预约管理', icon: 'order' },
    children: [
      {
        path: 'store',
        name: 'bkStore',
        component: () => import('@/views/booking/store/index'),
        meta: { title: '门店管理', icon: 'marker' }
      },
      {
        path: 'schedule',
        name: 'bkSchedule',
        component: () => import('@/views/booking/schedule/index'),
        meta: { title: '排课管理', icon: 'form' }
      },
      {
        path: 'course-type',
        name: 'bkCourseType',
        component: () => import('@/views/booking/courseType/index'),
        meta: { title: '团课类型', icon: 'product-cate' }
      },
      {
        path: 'session-template',
        name: 'bkSessionTemplate',
        component: () => import('@/views/booking/sessionTemplate/index'),
        meta: { title: '团课管理', icon: 'document' }
      },
      {
        path: 'workout-template',
        name: 'bkWorkoutTemplate',
        component: () => import('@/views/booking/workoutTemplate/index'),
        meta: { title: '训练模板', icon: 'documentation' }
      },
      {
        path: 'workout-exercise',
        name: 'bkWorkoutExercise',
        component: () => import('@/views/booking/workoutExercise/index'),
        meta: { title: '动作库', icon: 'list' }
      },
      {
        path: 'workout-plan',
        name: 'bkWorkoutPlan',
        component: () => import('@/views/booking/workoutPlan/index'),
        meta: { title: '训练计划', icon: 'edit' }
      },
      {
        path: 'coach',
        name: 'bkCoach',
        component: () => import('@/views/booking/coach/index'),
        meta: { title: '教练管理', icon: 'ums-role' }
      },
      {
        path: 'user',
        name: 'bkUser',
        component: () => import('@/views/booking/user/index'),
        meta: { title: '用户管理', icon: 'user' }
      },
      {
        path: 'booking',
        name: 'bkBooking',
        component: () => import('@/views/booking/booking/index'),
        meta: { title: '预约记录', icon: 'product-attr' }
      },
      {
        path: 'order',
        name: 'bkOrder',
        component: () => import('@/views/booking/order/index'),
        meta: { title: '订单管理', icon: 'order' }
      },
      {
        path: 'recharge-plan',
        name: 'bkRechargePlan',
        component: () => import('@/views/booking/rechargePlan/index'),
        meta: { title: '充值档位', icon: 'sms-coupon' }
      },
      {
        path: 'pt-product',
        name: 'bkPtProduct',
        component: () => import('@/views/booking/ptProduct/index'),
        meta: { title: '私教课管理', icon: 'product' }
      },
      {
        path: 'coach-pt-product',
        name: 'bkCoachPtProduct',
        component: () => import('@/views/booking/coachPtProduct/index'),
        meta: { title: '教练私教绑定', icon: 'ums-role' }
      },
      {
        path: 'ledger',
        name: 'bkLedger',
        component: () => import('@/views/booking/ledger/index'),
        meta: { title: '余额流水', icon: 'table' }
      }
    ]
  },
  {
    path: '/ums',
    component: Layout,
    redirect: '/ums/admin',
    name: 'ums',
    sort: 20,
    meta: { title: '权限', icon: 'ums' },
    children: [
      {
        path: 'admin',
        name: 'admin',
        component: () => import('@/views/ums/admin/index'),
        meta: { title: '用户列表', icon: 'ums-admin' }
      },
      {
        path: 'role',
        name: 'role',
        component: () => import('@/views/ums/role/index'),
        meta: { title: '角色列表', icon: 'ums-role' }
      },
      {
        path: 'allocMenu',
        name: 'allocMenu',
        component: () => import('@/views/ums/role/allocMenu'),
        meta: { title: '分配菜单' },
        hidden: true
      },
      {
        path: 'allocResource',
        name: 'allocResource',
        component: () => import('@/views/ums/role/allocResource'),
        meta: { title: '分配资源' },
        hidden: true
      },
      {
        path: 'menu',
        name: 'menu',
        component: () => import('@/views/ums/menu/index'),
        meta: { title: '菜单列表', icon: 'ums-menu' }
      },
      {
        path: 'addMenu',
        name: 'addMenu',
        component: () => import('@/views/ums/menu/add'),
        meta: { title: '添加菜单' },
        hidden: true
      },
      {
        path: 'updateMenu',
        name: 'updateMenu',
        component: () => import('@/views/ums/menu/update'),
        meta: { title: '修改菜单' },
        hidden: true
      },
      {
        path: 'resource',
        name: 'resource',
        component: () => import('@/views/ums/resource/index'),
        meta: { title: '资源列表', icon: 'ums-resource' }
      },
      {
        path: 'resourceCategory',
        name: 'resourceCategory',
        component: () => import('@/views/ums/resource/categoryList'),
        meta: { title: '资源分类' },
        hidden: true
      }
    ]
  },
  { path: '*', redirect: '/404', hidden: true }
]

export default new Router({
  // mode: 'history', //后端支持可开
  scrollBehavior: () => ({ y: 0 }),
  routes: constantRouterMap
})




// WEBPACK FOOTER //
// ./src/router/index.js